import RfeBackdrop from './rfeBackdrop';
import { Modal } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { RupDialog } from 'copyright-clearance-center-common-ui-react';
import { DialogActions } from 'copyright-clearance-center-common-ui-react/dist/components/rupDialog';
import React from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		dialogWrapper: {
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '100%',
			outline: '0',
			'& .rup-form-item:not(:last-child)': {
				marginBottom: '12px'
			}
		}
	})
);

export interface IModalWindowProps {
	title?: string | null;
	content: JSX.Element;
	actions?: DialogActions;
	open?: boolean;
	closeHandler: () => void;
	width?: string;
	scrollable?: boolean;
	danger?: boolean;
	maxHeight?: string;
	maxWidth?: string;
	disableAutoClose?: boolean;
	ellipsisTitle?: boolean;
}

const ModalWindow: React.FunctionComponent<IModalWindowProps> = props => {
	const classes = useStyles();

	const handleModalClose = () => {
		if (!props.disableAutoClose) {
			props.closeHandler();
		}
	};

	return (
		// 'Function components cannot be given refs' error -> added extra div wrapper (https://github.com/mui/material-ui/issues/15903)
		<Modal
			style={{ zIndex: 6000 }} // Proper backdrop, search control has zIndex: 5999 and was placed above the backdrop.
			open={props.open ?? true}
			onClose={handleModalClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			keepMounted={false}
			slots={{ backdrop: RfeBackdrop }}
			slotProps={{
				backdrop: {
					transitionDuration: 0,
					sx: {
						backgroundColor: 'lightgrey',
						opacity: '0.3 !important'
					}
				}
			}}
		>
			<div className={classes.dialogWrapper}>
				<RupDialog {...props} maxHeight={props.maxHeight ?? 'calc(100vh - 64px)'} />
			</div>
		</Modal>
	);
};

export default ModalWindow;
